export enum SemestersType {
  all = -1,
  custom = -2
}
